
import React from 'react';

const ChevronRight = (): JSX.Element => {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2553 1.25526C12.5816 2.92893 12.5816 5.6425 14.2553 7.31617L36.9391 30L14.2553 52.6838C12.5816 54.3575 12.5816 57.0711 14.2553 58.7447C15.9289 60.4184 18.6425 60.4184 20.3162 58.7447L46.0305 33.0305C47.7041 31.3568 47.7041 28.6432 46.0305 26.9695L20.3162 1.25526C18.6425 -0.418419 15.9289 -0.418419 14.2553 1.25526Z"
        />
    );
};

export default ChevronRight;
